<template>

  <!-- </van-pull-refresh> -->
<div>
<div class="cari-toolbar">
  <div class="cari-filters">
    <input
      v-model.trim="filters.kod"
      class="cari-input cari-input-sm"
      type="text"
      placeholder="KOD"
      @input="onFilterChange"
    >

    <input
      v-model.trim="filters.unvan"
      class="cari-input cari-input-unvan"
      type="text"
      placeholder="Ünvan"
      @input="onFilterChange"
    >

    <input
      v-model.trim="filters.vno"
      class="cari-input cari-input-sm"
      type="text"
      placeholder="VNO"
      @input="onFilterChange"
    >
  </div>
</div>

  <div class="modal-overlay active" v-if="detayac"></div>
  <div class="modal-overlay" v-if="planlama"></div>

<div class="cari-table-wrapper">
  <table class="cari-table">
    <thead>
      <tr class="fs14">
        <td>Kod</td>
        <td>Ünvan</td>
        <td>V.Daire</td>
        <td>V.No</td>
        <td>Bölge</td>
        <td>Telefon</td>
        <td>Bakiye</td>
        <td>Risk</td>
        <td>Extre</td>
        <td>Plan</td>
        <td>Teklif</td>
        <td>Link</td>
        <td>Sepet</td>
        <td>Yeni</td>
        <td>Seç</td>
      </tr>
    </thead>

    <tbody>
<tr
  v-for="(post, index) in cariler"
  :key="index"
  :data-kod="post.kod"
  :data-unvan="$helper.ilkharfBuyuk(post.unvan).substring(0, 50)"
>
  <!-- KOD & ÜNVAN: masaüstü için, mobilde başlığa taşınıyor -->
  <td class="col-kod">{{ post.kod.substring(0,11) }}</td>

  <td class="col-unvan">
    {{post.unvan.substring(0,40) }}
  </td>

  <!-- Vergi Dairesi artık info kutusu -->
  <td class="info-td info-vd" data-label="V.Daire">
    {{ $helper.ilkharfBuyuk(post.vd).substring(0, 15) }}
  </td>

  <!-- VNO info kutusu -->
  <td class="info-td info-vno" data-label="V.No">
    {{ $helper.ilkharfBuyuk(post.vno) }}
  </td>

  <!-- Bölge / Telefon (istersen mobilde gizleyeceğiz) -->
  <td class="col-bolge">
    {{ $helper.ilkharfBuyuk(post.bolge).substring(0, 15) }}
  </td>

  <td class="col-gsm">
    {{ post.gsm }}
  </td>

  <!-- BAKİYE info kutusu (tam satır) -->
  <td class="info-td info-bakiye" data-label="Bakiye">
    {{ $helper.parabirimi((post.bakiye ),hesap.pb) }}
  </td>

  <!-- RİSK info kutusu -->
  <td class="info-td info-risk" data-label="Risk">
    0
  </td>

  <!-- Aksiyon kolonları aynı, sadece class + data-label var -->
  <td class="action-td action-extre text-center" data-label="Extre">
    <a @click="cariSec(post,'/cari/extre/',true)" href="javascript:void(0)">
      <i class="icon-compare" style="font-size:23px;"></i>
    </a>
  </td>

  <!--<td class="action-td action-plan text-center" data-label="Plan">
    <a href="javascript:void(0)">
      <i @click="modul('Plan', 1)" style="font-size:23px" class="icon-calendar text-info"></i>
    </a>
  </td>
 cariSec(post,'/teklif/add/',true) -->
  <td class="action-td action-teklif text-center text-danger" data-label="Teklif">
    
    <i @click="modul('Teklif', 2)" class="icon-edit" style="font-size:20px; font-weight: 600;"></i>
  </td>
  <td class="action-td action-teklif text-center text-danger" data-label="Link">
    <i @click="modul('Ödeme Linki',3)" class="icon-clock" style="font-size:20px; font-weight: 600;"></i>
  </td>
  <td class="action-td action-sepet" data-label="Sepet">
    <a @click="cariSec(post,'/cari/sepet',true)" href="javascript:void(0)">
      <div class="mini-cart-icon mini-cart-icon-2">
        <a @click="cariSec(post,'/cari/sepet',true)" href="javascript:void(0)" style="min-width:auto">
          <span class="mini-cart-icon">
            <i class="icon-shopping-bags" style="font-weight:600;font-size:21px"></i>
            <sup>{{post.basket.length}}</sup>
          </span>
        </a>
      </div>
    </a> 
  </td>

  <td class="action-td action-yeni text-center" data-label="Yeni">
    <a @click="yenikullanici(post)" href="javascript:void(0)">
      <i class="icon-user text-center text-success" style="font-size:20px; font-weight: 600;"></i>
    </a>
  </td>

  <td class="action-td action-sec text-center" data-label="Seç">
    <a @click="cariSec(post,'/cari',true)" href="javascript:void(0)">
      <i style="font-size:20px; font-weight: 600;" class="icon-menu"></i>
    </a>
  </td>
</tr>



    </tbody>
  </table>
    <div ref="cariLoadTrigger" style="height: 1px;"></div>

  <div v-if="loadingMore" class="text-center my-3">Devamı yükleniyor...</div>
  <div v-if="!hasMore && cariler.length" class="text-center my-3"></div>
</div>

<Transition name="fade">
  <div v-if="detayac" class="modal-overlay" role="dialog" aria-modal="true">
    <div class="modal-card">

      <div class="modal-head">
        <h2 class="modal-title">Yeni Kullanıcı ({{ mode }})</h2>
        <button class="icon-x" @click="detayac=false" aria-label="Kapat">×</button>
      </div>

      <div class="modal-body">

        <div class="modal-tabs">
          <button
            type="button"
            class="modal-tab-btn"
            :class="{ active: detayTab === 'new' }"
            @click="detayTab = 'new'"
          >
            Yeni Kullanıcı
          </button>
          <button
            type="button"
            class="modal-tab-btn"
            :class="{ active: detayTab === 'active' }"
            @click="detayTab = 'active'"
          >
            Aktif Kullanıcı
          </button>
        </div>

        <template v-if="detayTab === 'new'">

        <!-- SATIR 1 -->
        <div class="form-grid-4">
          <div class="field">
            <div class="label">İsim - Soyisim (*)</div>
            <input type="text" v-model="obje.ad" class="form-control">
          </div>

          <div class="field">
            <div class="label">Kullanıcı Adı (*)</div>
            <input type="text" v-model="obje.username" class="form-control">
          </div>

          <div class="field">
            <div class="label">Şifre (*)</div>
            <input type="text" v-model="obje.password" class="form-control">
          </div>

          <div class="field">
            <div class="label">E-Posta</div>
            <input type="text" v-model="obje.mail" class="form-control">
          </div>
        </div>

        <!-- SATIR 2 -->
        <div class="form-grid-4 mt-12">
          <div class="field">
            <div class="label">İskonto</div>
            <input type="text" v-model="obje.iskonto" class="form-control" placeholder="0+0+0">
          </div>

          <div class="field">
            <div class="label">Ödeme İskonto</div>
            <input type="number" v-model.number="obje.ekiskonto" class="form-control" placeholder="0">
          </div>

          <div class="field">
            <div class="label">Depo</div>
<select v-model="obje.depo" class="form-control">
  <option disabled value="">Seçiniz</option>
  <option
    v-for="d in depoOptions"
    :key="d.id || d.value || d"
    :value="(d && d.value !== undefined && d.value !== null) ? d.value : d"
  >
    {{ (d && d.label) ? d.label : ((d && d.name) ? d.name : d) }}
  </option>
</select>

          </div>

          <div class="field">
            <div class="label">Telefon</div>
            <input type="text" v-model="obje.telefon" class="form-control" placeholder="05xx xxx xx xx">
          </div>
        </div> 

        </template>

        <template v-else>
          <div class="active-users-panel list-mode">
            <div v-if="aktifKullanicilarLoading" class="active-users-empty">
              Bu mÃ¼ÅŸteriye ait aktif kullanÄ±cÄ±lar bu sekmede listelenecek.
            </div>
            <div v-else-if="aktifKullanicilarError" class="active-users-empty text-danger">
              {{ aktifKullanicilarError }}
            </div>
            <div v-else-if="!aktifKullanicilar.length" class="active-users-empty">
              Bu musteriye bagli aktif kullanici bulunamadi.
            </div>
            <div v-else class="table-responsive">
              <table class="table table-hover table-bordered bg-white active-users-table">
                <thead>
                  <tr>
                    <th>Kullanici Adi</th>
                    <th>Sifre</th>
                    <th>Mail</th>
                    <th class="text-right">Islem</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in aktifKullanicilar" :key="'au-' + item.id">
                    <td>{{ item.username || '-' }}</td>
                    <td>{{ item.password || '-' }}</td>
                    <td>{{ item.mail || '-' }}</td>
                    <td class="active-users-table-actions">
                      <button
                        v-if="item.mail"
                        type="button"
                        class="btn btn-success btn-sm active-users-mail-btn" style="height: 35px; background: darkslateblue;"
                        @click="aktifKullaniciMailGonder(item)"
                      >
                        Mail Gonder
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>

      </div>

      <div class="modal-foot">


        <button @click="detayac=false" class="btn btn-orange w-180">İPTAL</button>
        <button v-if="detayTab === 'new'" @click="yeni()" class="btn btn-blue w-240">
          {{ mode === 'edit' ? 'KULLANICI GÜNCELLE' : 'KULLANICI EKLE' }}
        </button>
      </div>

    </div>
  </div>
</Transition>

  <Transition>
    <div class="modals" role="dialog" v-if="planlama">
      <h2 class="text-left h2" style="font-size:17px">Yeni Müşteri Zİyareti</h2>
      <div class="container-fluid">
        <div class="row mt-3">
          <div class="col-6">
            <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Ziyaret Sebebi</h2>

            <select class="form-control" v-model="planbeya.sebep" style="height:45px">
              <option value="Satış" selected> Satış </option>
              <option value="Ödeme"> Ödeme </option>
              <option value="Ziyaret"> Ziyaret </option>
              <option value="Demo"> Demo </option>

              <option value="Diğer"> Diğer </option>
            </select>

          </div>
          <div class="col-6">
            <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Tarih</h2>

            <input type="date" v-model="planbeya.tarih" class="form-control">

          </div>

        </div>
        <div class="row mt-1">
          <div class="col-12">
            <h2 class="text-left h2 my-2" style="font-size:15px; width: 95%;">Bilgi</h2>

            <textarea class="form-control" v-model="planbeya.text" height="500px"></textarea>


        </div>
      </div>
      
        <div class="row mt-3">

          <div class="col-3 text-left"><button @click="planlama=false" class="btn btn-orange btn-sm text-center w-100"><span class="fs13">İPTAL</span></button></div>
          <div class="col-9 text-right"><button @click="planekle()" class="btn btn-blue btn-sm text-center d-block w-100"><span class="fs13">PLANLA</span></button></div>

        </div>            
      </div>
    </div>

  </Transition>      

</div>

</template>

<script>
import { router } from '@/router';
import db from '../../db';
import cari from '../../services/cari';


export default {
  data() {
    return {
      planbeya:{
        sebep:'Diğer',
        tarih:'',
        text:'Bilgi'
      },
      hesap:this.$request.ayar(),
      detayac : false,
      planlama:false,
      obje : {
         ad:'',
         username:'',
         password:'',
         depo:"1", // sabit depo
         ekip:"1", // sabit depo

         mail:'',
         mailPass:'',
         telefon:'',
         aktif:true,
         entegrekodu:false,
         iskonto:"0+0+0",
         ekiskonto:0,
         root:false
        },
      obj: {
        pkod:this.$request.ayar().entegrekodu,
        ckod:0,
        search: null,
        sayfa: 1,
        toplam: 0,
      },
      mesaj : '',
      search:'',
      mode:"KULLANICI EKLE", // modal başlık
      detayTab: 'active',
      aktifguid : 0,
      aktifKullanicilar: [],
      aktifKullanicilarLoading: false,
      aktifKullanicilarError: "",
      //v3
      cariler: [],
      loading: false,
      loadingMore: false,
    page: 0,
    perPage: 50,
    hasMore: true,
    observer: null,
      depoOptions: [],
    ekipOptions: [],
    filters: {
        vno: "",
        vd: "",
        unvan: "",
        kod:""
      },

      totalCount: 0,
      _filterTimer: null
    
    };
  },

async created(){
    this.$store.setLoading([false,''])
    this.detayac = false;
    this.planlama = false
},

  mounted() {
  this.loadCarilerInitial();
  this.initCariObserver();
},
beforeDestroy() {
    if (this.observer) this.observer.disconnect();
    if (this._filterTimer) clearTimeout(this._filterTimer);},
methods:{
  modul(modul,id){
      this.$store.showNotify({
        type: 'danger',
        text: modul + ` Modülü Pasif`,
        timeout: 3000
      });
  },
    planekle(){
      this.plan = true;
      let plans = {
        sebep:this.planbeya.sebep,
        tarih:this.planbeya.tarih,
        text:this.planbeya.text,
        kid:this.hesap.kid,
        baslik:this.$store.getters.getCari.aktif.unvan,
        ckod:this.$store.getters.getCari.aktif.kod
      }
        console.log(plans)

        this.$request.post('crm/planlama/add',plans,this.hesap).then(res=>{
          // console.log(res)
          if (res.status != 309) {
            let bildirimObje = {
                tip:3,
                alias:'Planlama',
                renk:'danger',
                link:'planlama',
                seri:"P",
                sira:res.result,
                kid:this.hesap.kid,
                baslik:this.$store.getters.getCari.aktif.unvan,
                ckod:this.$store.getters.getCari.aktif.kod,
                names:this.hesap.kad// sadece mail için

              }
              this.$request.post("crm/bildirim/add", bildirimObje,this.hesap)
              setTimeout(() => {
                this.$store.commit("setLoading",[false,'...'])

                  this.$swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Planlama Başarı ile eklendi",
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.planlama = false
              }, 1000);
          }
          else{
            this.$notify({ type: 'danger', message: "Oturum Hatası" });
            this.$router.push("/oturum")
          }
        }).catch((err)=>{
          this.$store.commit("setLoading",[false,'...']);  
          this.$notify({ type: 'danger', message: err.message });
        })  
    },
    async cariSec(post,link,islem) {
          this.$store.setLoading([true,'Bekleyiniz'])

      try {
        await cari.carisec(post.guid,this.$request);
        // this.$store.setLoading([false,'Bekleyiniz'])
        if (islem) {
           router.push(link)
          // this.$request.post('mikro/warm-up',{}).then(res=>{
          //   if(res.status) { 
          //     setTimeout(() => { router.push(link) }, 100);
          //   }
          //   else{ this.$router.push("/oturum") }
          // })
        }  
        // local listeyi de güncelle (liveQuery kullanmıyorsan lazım)
        //this.cariler = await db.caris.orderBy('unvan').toArray();

        // aktifCari zaten store içindeki liveQuery ile güncellenecek
      } catch (e) {
        console.error('Cari seçilirken hata:', e);
      } 
    },
    async aktifKullaniciListele() {
      if (!this.aktifguid) {
        this.aktifKullanicilar = [];
        return;
      }

      this.aktifKullanicilarLoading = true;
      this.aktifKullanicilarError = "";
      try {
        const res = await this.$request.post('crm/kullanici/list/by-cari', { yid: this.aktifguid });
        const body = res && res.data ? res.data : res;
        if (!body || body.status == 309 || body.status == 400 || body.status === false) {
          throw new Error((body && body.msg) || 'Kullanicilar getirilemedi');
        }
        this.aktifKullanicilar = Array.isArray(body)
          ? body
          : (Array.isArray(body.data) ? body.data : []);
      } catch (err) {
        this.aktifKullanicilar = [];
        this.aktifKullanicilarError = (err && err.message) ? err.message : 'Kullanicilar getirilemedi';
      } finally {
        this.aktifKullanicilarLoading = false;
      }
    },
    async aktifKullaniciSil(item) {
      const kid = item && item.id ? item.id : 0;
      if (!kid || !this.aktifguid) return;

      const ok = window.confirm('Bu kullanici tamamen silinsin mi?');
      if (!ok) return;

      this.$store.setLoading([true,'Bekleyiniz']);
      try {
        const res = await this.$request.post('crm/kullanici/delete', {
          kid: kid,
          yid: this.aktifguid
        });
        const body = res && res.data ? res.data : res;
        if (!body || body.status === false) {
          throw new Error((body && body.msg) || 'Silme islemi basarisiz');
        }
        this.aktifKullanicilar = (this.aktifKullanicilar || []).filter(x => Number(x.id) !== Number(kid));
        this.$store.showNotify({ type: 'success', text: 'Kullanici silindi', timeout: 2000 });
      } catch (err) {
        this.$store.showNotify({ type: 'danger', text: (err && err.message) ? err.message : 'Silme islemi basarisiz', timeout: 3000 });
      } finally {
        this.$store.setLoading([false,'']);
      }
    },
    async aktifKullaniciMailGonder(item) {
      const kid = item && item.id ? item.id : 0;
      if (!kid || !item.mail) return;

      this.$store.setLoading([true,'Bekleyiniz']);
      try {
        const res = await this.$request.post('crm/kullanici/send-credentials', {
          kid: kid,
          mail: item.mail
        });
        const body = res && res.data ? res.data : res;
        if (!body || body.status === false) {
          throw new Error((body && body.msg) || 'Mail gonderilemedi');
        }
        this.$store.showNotify({ type: 'success', text: body.msg || 'Mail gonderildi', timeout: 2000 });
      } catch (err) {
        this.$store.showNotify({ type: 'danger', text: (err && err.message) ? err.message : 'Mail gonderilemedi', timeout: 3000 });
      } finally {
        this.$store.setLoading([false,'']);
      }
    },
    yenikullanici(post){
        this.detayTab = 'active';
        this.obje.ad='';
        this.obje.username='';
        this.obje.password='';
        this.obje.depo=0;

        this.obje.ekip=0;

        this.obje.mail=post.mail;
        this.obje.mailPass=0;
        this.obje.aktif=true;
        this.obje.entegrekodu=false;
        this.detayac = true;
        this.obje.iskonto="0+0+0";
        this.obje.ekiskonto=0;
        this.obje.root=false;
        this.mode = post.unvan;
        this.aktifguid = post.guid;
        this.aktifKullanicilar = [];
        this.aktifKullanicilarError = "";
        this.aktifKullaniciListele();
      },
      yeni(){
        var _ = this.obje
        if (_.ad == '' || _.username == '' || _.password == '') {
            this.$store.setLoading([false,''])
              this.$store.showNotify({
                type: 'danger',
                text: "Yıldızlı alanları doldur",
                timeout: 3000
              });
        }
        else {
        this.detayac = true;
        this.$store.setLoading([true,'Bekleyiniz'])
        this.$request.post('crm/kullanici/add',this.obje).then(res=>{
          if (res.status != 309) {
            console.log(res)
            this.kayit(res.recordId)
          }
          else{
              this.$store.showNotify({
                type: 'danger',
                text: "Oturum Hatası",
                timeout: 3000
              });
            //this.$router.push("/oturum")
          }
        }).catch((err)=>{
            this.$store.setLoading([false,''])
              this.$store.showNotify({
                type: 'danger',
                text: err.message,
                timeout: 3000
              });        
          })           
        }

 
      },
      kayit(kid){

        let request = {
          kid :kid,
          yid:this.aktifguid,
          alias : 'cari',
          durum :false
        }
        this.$request.post('crm/yetki',request).then(res=>{
          if (res.status) {
            this.detayac = false;
            this.$store.setLoading([false,''])
              this.$store.showNotify({
                type: 'success',
                text: "Başarılı",
                timeout: 3000
              });             
            }
          else {
              this.$store.showNotify({
                type: 'danger',
                text: "Yetki verilemedi, teknik i ara",
                timeout: 3000
              });             }
            this.$store.setLoading([false,''])

        }).catch((err)=>{
            this.$store.setLoading([false,''])
        }) 
      },      
async loadCarilerInitial () {
  this.loading = true;
  try {
    this.page = 0;
    this.hasMore = true;
    this.cariler = [];

    // Toplam (filtrelenmiş)
    this.totalCount = await this.buildCariQuery().count();

    // İlk parça (filtrelenmiş)
    const chunk = await this.buildCariQuery()
      .offset(0)
      .limit(this.perPage)
      .toArray();

    this.cariler = chunk;
    this.page = 1;

    if (chunk.length < this.perPage) this.hasMore = false;
  } catch (e) {
    console.error('Cari listesi yüklenirken hata:', e);
  } finally {
    this.loading = false;
  }
},
 
async loadMoreCariler() {
  if (this.loadingMore || !this.hasMore || this.loading) return;

  this.loadingMore = true;
  try {
    const skip = this.page * this.perPage;

    // Devam (filtrelenmiş)
    const chunk = await this.buildCariQuery()
      .offset(skip)
      .limit(this.perPage)
      .toArray();

    if (!chunk.length) {
      this.hasMore = false;
      return;
    }

    this.cariler.push(...chunk);
    this.page++;

    if (chunk.length < this.perPage) this.hasMore = false;
  } catch (e) {
    console.error('Cari devam yüklemede hata:', e);
  } finally {
    this.loadingMore = false;
  }
},


  initCariObserver() {
    const options = { root: null, rootMargin: '150px', threshold: 0 };

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) this.loadMoreCariler();
    }, options);

    this.$nextTick(() => {
      if (this.$refs.cariLoadTrigger) {
        this.observer.observe(this.$refs.cariLoadTrigger);
      }
    });
  }      ,
      onFilterChange() {
      if (this._filterTimer) clearTimeout(this._filterTimer);
      this._filterTimer = setTimeout(() => {
        this.loadCarilerInitial();
      }, 250);
    },

    // filtrelenmiş query builder
    buildCariQuery() {
      // orderBy ile sıralayıp client-side filter uyguluyoruz.
      // Not: Eğer vno/vd/unvan indexlerin varsa, daha optimize edilebilir.
      const fVno = (this.filters.vno || "").toLowerCase();
      const fVd = (this.filters.vd || "").toLowerCase();
      const fUnvan = (this.filters.unvan || "").toLowerCase();
            const fKod = (this.filters.kod || "").toLowerCase();


      return db.caris
        .orderBy("unvan")
        .filter((c) => {
          // alan adlarını senin objene göre uyarlayabilirsin: vno/vd/unvan
          const vno = String(c.vno || "").toLowerCase();
          const vd = String(c.vd || "").toLowerCase();
          const unvan = String(c.unvan || "").toLowerCase();
          const kod = String(c.kod || "").toLowerCase();

          if (fVno && !vno.includes(fVno)) return false;
          if (fVd && !vd.includes(fVd)) return false;
          if (fUnvan && !unvan.includes(fUnvan)) return false;
          if (fKod && !kod.includes(fKod)) return false;

          return true;
        });
    }, 
}
};
</script>
<style scoped>

/* overlay */
.modal-overlay{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.modal-card{
  width: min(1200px, 96vw); /* 4 sütun için geniş */
  max-height: 92vh;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 18px 60px rgba(0,0,0,.25);
  display: flex;
  flex-direction: column;
}

.modal-head{
  padding: 14px 16px;
  border-bottom: 1px solid #e6e9ef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.modal-title{ margin:0; font-size:17px; font-weight:700; }

.icon-x{
  width: 34px; height: 34px;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  background:#fff;
  cursor:pointer;
  font-size:20px;
}

.modal-body{
  padding: 16px;
  overflow: auto;
}

.modal-tabs{
  display:flex;
  gap:10px;
  margin-bottom:16px;
  border-bottom:1px solid #e6e9ef;
  padding-bottom:12px;
}

.modal-tab-btn{
  height:40px;
  padding:0 16px;
  border:1px solid #dbe2ea;
  border-radius:10px;
  background:#fff;
  color:#334155;
  font-weight:600;
  cursor:pointer;
}

.modal-tab-btn.active{
  background:#0f172a;
  border-color:#0f172a;
  color:#fff;
}

.active-users-panel{
  min-height:220px;
  display:flex;
  align-items:center;
  justify-content:center;
  border:1px dashed #dbe2ea;
  border-radius:12px;
  background:#f8fafc;
  padding:20px;
}

.active-users-empty{
  color:#64748b;
  font-size:14px;
  text-align:center;
}

.active-users-panel.list-mode{
  min-height:220px;
  display:block;
  border-style:solid;
}

.active-users-table{
  margin-bottom:0;
}

.active-users-table-actions{
  white-space:nowrap;
}

.active-users-mail-btn{
  min-width: 78px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
  box-shadow: none;
}

.active-user-list{
  display:flex;
  flex-direction:column;
  gap:10px;
}

.active-user-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  padding:12px 14px;
  border:1px solid #e6e9ef;
  border-radius:10px;
  background:#fff;
}

.active-user-main{
  min-width:0;
  flex:1;
}

.active-user-name{
  font-size:14px;
  font-weight:700;
  color:#111827;
  margin-bottom:4px;
}

.active-user-sub{
  display:flex;
  flex-wrap:wrap;
  gap:10px;
  font-size:12px;
  color:#64748b;
}

.active-user-remove{
  width:auto;
  min-width:86px;
  height:38px;
  padding:0 14px;
}

/* 4 input yan yana - sabit */
.form-grid-4{
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  align-items: start;
}

.field{ min-width:0; }

.label{
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 6px 0;
  color:#111827;
}

.form-control{
  width:100%;
  height:42px;
  padding:0 12px;
  border:1px solid #e6e9ef;
  border-radius:8px;
  outline:none;
  background:#fff;
}

.form-control:focus{
  border-color:#cbd5e1;
  box-shadow:0 0 0 3px rgba(148,163,184,.25);
}

.mt-12{ margin-top:12px; }

.modal-foot{
  padding: 14px 16px;
  border-top: 1px solid #e6e9ef;
  display:flex;
  align-items:center;
  justify-content:flex-end;
  gap:12px;
}

.active-wrap{
  margin-right:auto;
  display:flex;
  align-items:center;
  gap:12px;
  font-weight:600;
}

.btn{
  height:42px;
  border:0;
  border-radius:10px;
  padding:0 14px;
  font-weight:700;
  cursor:pointer;
  color:#fff;
}
.btn-orange{ background:#f59e0b; }
.btn-blue{ background:#1d4ed8; }
.w-180{ width:180px; }
.w-240{ width:240px; }

.fade-enter-active, .fade-leave-active{ transition: opacity .15s ease; }
.fade-enter, .fade-leave-to{ opacity: 0; }




/* --- GENEL TABLO --- */
/* Dış sarmalayıcı */
.cari-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

/* Genel tablo */
.cari-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.cari-table thead td,
.cari-table thead th {
  background: #f2f2f2;
  font-weight: 600;
}

.cari-table td,
.cari-table th {
  padding: 8px 10px;
  border-bottom: 1px solid #e5e5e5;
  white-space: nowrap;
}

/* Desktop (>= 1024px) */
@media (min-width: 1024px) {
  .cari-table {
    font-size: 14px;
  }

  .cari-table td,
  .cari-table th {
    padding: 10px 12px;
  }
}

/* Tablet (768px - 1023px) */
@media (max-width: 1023px) {

  .cari-table thead {
    display: none;
  }

  .cari-table tr {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;
    background: #fff;
    padding: 10px 12px 14px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    position: relative;
  }

  .cari-table td {
    border: none;
    padding: 4px 0;
    font-size: 13px;
  }

  /* ------------------------------------
      1. SATIR: Firma kodu + firma ismi
  ------------------------------------ */
  .cari-table tr::before {
    content: attr(data-kod) " - " attr(data-unvan);
    width: 100%;
    display: block;
    text-align: center;
    font-weight: 600;
    margin-bottom: 10px;
    padding: 8px;
    font-size: 14px;

    /* Soft renklendirme */
    background: #f4f8ff;
    border: 1px solid #e5ecf9;
    border-radius: 8px;
  }

  .cari-table td.col-kod,
  .cari-table td.col-unvan {
    display: none;
  }

  /* Bölge / Telefon mobilde istenmiyor */
  .cari-table td.col-bolge,
  .cari-table td.col-gsm {
    display: none;
  }

  /* ------------------------------------
      2. SATIR: 4’lü bilgi grubu
      V.Daire – V.No – Risk – Bakiye
  ------------------------------------ */

  .cari-table td.info-td {
    display: flex;
    flex-direction: column;
    padding: 6px 6px;
    font-size: 12px;
    background: #fafafa;
    border-radius: 6px;
    margin: 3px;
    border: 1px solid #f0f0f0;
  }

  .cari-table td.info-td::before {
    content: attr(data-label);
    font-size: 11px;
    color: #777;
    margin-bottom: 2px;
    font-weight: 500;
  }

  /* 4 kolon → %25 genişlik */
  .cari-table td.info-vd,
  .cari-table td.info-vno,
  .cari-table td.info-risk,
  .cari-table td.info-bakiye {
    width: calc(25% - 6px);
  }

  .cari-table td.info-vd     { order: 10; }
  .cari-table td.info-vno    { order: 11; }
  .cari-table td.info-risk   { order: 12; text-align: center; }
  .cari-table td.info-bakiye { order: 13; text-align: right; }

  /* ------------------------------------
      3. SATIR: ICON GRUBU (6’lı)
  ------------------------------------ */

  .cari-table td.action-td {
    width: calc(100% / 6 - 6px);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6px 2px;
    margin: 8px 3px 0;
    order: 20;

    background: #fafafa;
    border-radius: 6px;
    border: 1px solid #eee;
  }

  .cari-table td.action-td::before {
    content: attr(data-label);
    font-size: 10px;
    margin-bottom: 4px;
    font-weight: 600;
    color: #555;
  }

  .cari-table td.action-td i {
    font-size: 18px;
  }

  .cari-table td.action-td:hover {
    background: #f3f7ff;
    border-color: #dce7ff;
  }
}

/* GENEL INPUT STİLİ */
/* GENEL INPUT + SELECT + TEXTAREA STİLİ */
input[type="text"],
input[type="number"],
input[type="search"],
input[type="email"],
input[type="password"],
select,
textarea {
  width: 100%;
  height: 46px;
  padding: 0 14px;
  font-size: 14px;
  color: #333;

  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 8px;

  outline: none;
  transition: 0.18s ease;
  box-sizing: border-box; 
}

/* Hover */
input:hover,
select:hover,
textarea:hover {
  border-color: #b8b8b8;
}

/* Focus */
input:focus,
select:focus,
textarea:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.18);
}

/* Placeholder */
input::placeholder,
textarea::placeholder {
  color: #999;
}

/* Textarea */
textarea {
  min-height: 90px;
  padding-top: 10px;
  padding-bottom: 10px;
  resize: vertical;
}


.btn {
  border-radius: 8px;
  font-size: 14px;
  padding: 8px 10px;
  border: 1px solid transparent;
  cursor: pointer;
}

.btn-sm {
  padding: 7px 10px;
}

/* İptal */
.btn-orange {
  background: #ff9800;
  border-color: #ff9800;
  color: #fff;
}
.btn-orange:hover {
  background: #fb8c00;
  border-color: #fb8c00;
}

/* Kullanıcı ekle */
.btn-blue {
  background: #004aad;
  border-color: #004aad;
  color: #fff;
}
.btn-blue:hover {
  background: #003a87;
  border-color: #003a87;
}
/* ====== CARI TOOLBAR (TEK DOĞRU SÜRÜM) ====== */

.cari-toolbar{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:14px;
  padding:15px;
}

/* Sol blok: 3 input tek satır */
.cari-filters{
  display:flex;
  align-items:center;
  gap:10px;
  flex:1;
  min-width:0;           /* Ünvanın taşmadan kısalabilmesi için kritik */
}

/* Ortak input */
.cari-input{
  height:45px;
  padding:0 12px;
  border:1px solid #e5e7eb;
  border-radius:10px;
  outline:none;
  background:#fff;
  min-width:0;
}

/* Ünvan: en uzun, tüm boşluğu alır */
.cari-input-unvan{
  flex:1;
}

/* VD + VNO: kısa ve eşit */
.cari-input-sm{
  width:120px;
  flex:0 0 120px;
}

/* Sağ blok: toplam + yeni yan yana */
.cari-right{
  display:flex;
  align-items:center;
  gap:10px;
  flex-shrink:0;
}

.cari-count{
  height:45px;
  display:flex;
  align-items:center;
  padding:0 12px;
  border:1px solid #e5e7eb;
  border-radius:10px;
  background:#fff;
  white-space:nowrap;
}

.cari-add-btn{
  height:45px;
  min-width:190px;        /* buton geniş */
  padding:0 18px;
  border:none;
  border-radius:10px;
  background:#1d4ed8;
  color:#fff;
  cursor:pointer;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px;
}

.cari-add-btn i{
  font-size:14px;
}

/* ====== MOBIL ======
   İsteğin: "mobilde ünvanı uzatsam yeter"
   Bu nedenle layout bozmuyoruz; sadece VD/VNO küçülüyor, Ünvan daha baskın kalıyor.
*/
@media (max-width: 768px){
  .cari-toolbar{
    gap:10px;
    padding:12px;
  }

  .cari-input{
    height:45px;
  }
.cari-filters{
  display:flex;
  align-items:center;
  gap:10px;
  flex:1;
  min-width:0;           /* Ünvanın taşmadan kısalabilmesi için kritik */
}
  .cari-input-sm{
    width:90px;
    flex:0 0 90px;
  }

  .cari-add-btn{
    min-width:150px;
    padding:0 14px;
  }
}
.cari-toolbar,
.cari-filters,
.cari-table-wrapper {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
}

.cari-input {
  min-width: 0;
  width: auto;
}

.cari-input-unvan,
.cari-unvan {
  flex: 1 1 0;
  min-width: 0;
  width: 0;
}

.cari-input-sm,
.cari-small {
  flex: 0 0 72px;
  width: 72px;
}

@media (max-width: 768px) {
  input,
  select,
  textarea {
    font-size: 16px !important;
  }

  .cari-toolbar {
    overflow: hidden;
  }

  .cari-filters {
    overflow: hidden;
    gap: 8px;
  }

  .cari-input-unvan,
  .cari-unvan {
    flex: 1 1 0;
    min-width: 0;
    width: 0;
  }

  .cari-input-sm,
  .cari-small {
    flex: 0 0 64px;
    width: 64px;
  }
}
  </style>
  
  



// WEBPACK FOOTER //
// src/views/cari/list.vue